<template>
  <div class="forbidden-page">
    <v-card class="pa-8 text-center elevation-0">
      <v-icon size="64" color="grey darken-1" class="mb-4">mdi-lock-outline</v-icon>
      <h2 class="mb-2">{{ $store.getters.t ? $store.getters.t('접근 권한이 없습니다.') : '접근 권한이 없습니다.' }}</h2>
      <p class="mb-6">
        {{ $store.getters.t ? $store.getters.t('관리자에게 문의하여 권한을 요청해 주세요.') : '관리자에게 문의하여 권한을 요청해 주세요.' }}
      </p>
      <v-btn color="primary" @click="goDashboard">
        {{ $store.getters.t ? $store.getters.t('대시보드로 이동') : '대시보드로 이동' }}
      </v-btn>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenPage',
  methods: {
    goDashboard() {
      this.$router.push('/dashboard');
    }
  }
};
</script>

<style scoped>
.forbidden-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fb;
}
</style>
